import React, { useState, useEffect } from "react";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useParams, useHistory } from "react-router-dom";

import CityList from "../../components/City/CityList";
import CityFormModal from "../../components/City/CityFormModal";
import ListPagination from "../../components/Common/ListPagination";
import * as CityActions from "../../store/actions/City";
import Permission from "../../components/Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { getPath } from "../../utils";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import FilterButton from "../../components/Common/FilterButton";

const City = (props) => {
  const params = useParams();
  const history = useHistory();
  const [modalState, setModalState] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.CITY];

  const filterFields = ["state_id", "city_name"];
  const shouldRenderList =
    getPath(params, "id", undefined) === undefined ? true : false;

  const handleClick = (type, id) => {
    setModalState(type);
    setActiveId(id);
  };

  const handleClose = () => {
    setModalState(false);
    setActiveId("");
    props.resetStateCity({ state: "activeCity" });
    if (
      history.location.pathname !== "/cities" &&
      getPath(props.cityList, "length", -1) > 0
    ) {
      //no page refresh, hence redux store will persist
      window.history.pushState("", "", "/cities");
    } else if (
      history.location.pathname !== "/cities" &&
      getPath(props.cityList, "length", -1) === 0
    ) {
      // clear everything and page refresh
      history.push("/cities");
    }
  };

  // handle pagination
  const handleNavClick = (action) => {
    const pageRequest = { page: currentPage };
    if (action === "prev") {
      pageRequest.page = currentPage - 1;
    } else {
      pageRequest.page = currentPage + 1;
    }
    setCurrentPage(pageRequest.page);
    props.getCityList(props.activeFilters, pageRequest);
  };

  const getModal = () => {
    const defaultProps = {
      activeId: activeId,
      modalState: modalState,
      handleClose: handleClose,
      stateList: props.stateList,
    };

    switch (modalState) {
      case "Add":
      case "Edit":
        return <CityFormModal {...defaultProps} />;
      case "Filter":
        return <CityFormModal {...defaultProps} filterFields={filterFields} />;
      default:
        return;
    }
  };

  useEffect(() => {
    if (shouldRenderList === true) {
      props.getCityList();
    } else {
      handleClick("Edit", params.id);
    }
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFilters)]);

  return (
    <div className="City-View container">
      <FlexContainer align="flex-start">
        <Heading>Cities</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={props.activeFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="CitiesAddBtn"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <Permission requiredPerms={[allActions.LIST]}>
        <CityList cityList={props.cityList} />
        <ListPagination
          nextPage={props.nextPage}
          prevPage={props.prevPage}
          handleNavClick={handleNavClick}
        />
      </Permission>
      {modalState && getModal()}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { City } = state;
  return {
    cityList: City.cityList,
    nextPage: City.nextPage,
    prevPage: City.prevPage,
    activeFilters: City.activeFilters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    resetStateCity: bindActionCreators(CityActions.resetState, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(City);
